import { jsxs, jsx } from "react/jsx-runtime";
const IllustrationErrorSvg = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: 64,
    height: 64,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsxs("g", { clipPath: "url(#a)", children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M30 58.552C14.236 58.552 1.448 45.764 1.448 30S14.236 1.448 30 1.448 58.552 14.236 58.552 30 45.764 58.552 30 58.552Zm0-53.565C16.166 4.987 4.987 16.167 4.987 30c0 13.753 11.18 25.013 25.013 25.013 13.834 0 25.013-11.18 25.013-25.013 0-13.834-11.26-25.013-25.013-25.013Z",
            fill: "#E99891"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M30 1.448c15.764 0 28.552 12.788 28.552 28.552S45.764 58.552 30 58.552 1.448 45.764 1.448 30 14.236 1.448 30 1.448ZM30 0C13.432 0 0 13.432 0 30c0 16.568 13.432 30 30 30 16.568 0 30-13.432 30-30C60 13.432 46.488 0 30 0Z",
            fill: "#C34E38"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M30 35.308c-1.126 0-2.091-.884-2.172-2.01l-.563-16.408A2.751 2.751 0 0 1 30 13.995c1.608 0 2.815 1.287 2.734 2.895l-.563 16.327c-.08 1.126-1.045 2.091-2.171 2.091Zm-2.976 5.711c0-.965.241-1.69.724-2.172.482-.482 1.206-.724 2.171-.724.965 0 1.609.242 2.172.724.483.483.724 1.207.724 2.091 0 .885-.241 1.609-.804 2.091-.483.483-1.207.724-2.172.724-.965 0-1.69-.241-2.172-.724-.402-.402-.643-1.126-.643-2.01Z",
            fill: "#C34E38"
          }
        )
      ] }),
      /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "a", children: /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M0 0h60v60H0z" }) }) })
    ]
  }
);
export {
  IllustrationErrorSvg
};
